import BaseProxy from './Proxy';

export default class SubstoreProductAvailabilityProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/productAvailability', parameters);
  }

  find(subscriptionTemplateId) {
    return this.submit('get', `${this.endpoint}/${subscriptionTemplateId}`);
  }
}
